<ng-container *transloco="let t">
    <div *ngFor="let thisQuestion of thisQuestions; let indx = index;">
        <div [ngSwitch]="thisQuestion.type" class="question-container">
            <div *ngSwitchCase="1">
                <div [ngClass]="{'hide': viewTicket !== indx}">
                    <h1 class="tui-space_bottom-10">{{ t('tickets.ticket') }} {{numbTicket}}, {{ t('tickets.question') }} {{indx + 1}} / {{questionsCount}}</h1>
                    <h2 class="tui-space_bottom-4">{{ t('tickets.ego_state_question') }}</h2>
                    <img class="img-text tui-space_top-5 tui-space_bottom-1 skeleton-img"
                        src="{{environment.assertsUrl}}i/{{this.numbTicket}}_{{indx+1}}.jpg">  
    
                    <p class="tui-space_bottom-5 tui-space_top-3 tui-text_body-xl question-blk">{{ t(thisQuestion.q) }}</p>
                    <div tuiAppearance="secondary" class="btnsBlk" tuiButtonGroup>
                        <button type="button" (click)="btnAnswerType1(indx,0)">
                            <tui-icon icon="@tui.notebook-text" />
                            {{ t('tickets.parent') }}
                        </button>
                        <button type="button" (click)="btnAnswerType1(indx,1)">
                            <tui-icon icon="@tui.chart-spline" />
                            {{ t('tickets.adult') }}
                        </button>
                        <button type="button" (click)="btnAnswerType1(indx,2)">
                            <tui-icon icon="@tui.volleyball" />
                            {{ t('tickets.child') }}
                        </button>
                    </div>
                </div>
            </div>
            <div *ngSwitchCase="2">
                <div [ngClass]="{'hide': viewTicket !== indx}">
                    <h1 class="tui-space_bottom-10">{{ t('tickets.ticket') }} {{numbTicket}}, {{ t('tickets.question') }} {{indx + 1}} / {{questionsCount}}</h1>
                    <h2 class="tui-space_bottom-4">{{ t('tickets.how_would_respond') }} {{t('tickets.'+categoryPerson[thisQuestion.state].key.toLocaleLowerCase())}}?</h2>
                    <img class="img-text tui-space_top-5 tui-space_bottom-1 skeleton-img"
                        src="{{environment.assertsUrl}}i/{{this.numbTicket}}_{{indx+1}}.jpg">
                    <p class="tui-space_bottom-5 tui-space_top-3 tui-text_body-xl question-blk">{{ t(thisQuestion.q) }}</p>
                    <form orientation="vertical" tuiGroup class="group tui-space_top-3 tui-space_bottom-3 form-answers"
                        [collapsed]="true" [formGroup]="type2QuestionsForm">
                        <label tuiBlock [style.justify-content]="'space-between'"
                            *ngFor="let answer of thisQuestion.a;  let indxAns = index;">
                            {{ t(answer) }}
                            <input formControlName="type2QuestionsValue" tuiRadio type="radio" value="{{ t(answer) }}"
                                (click)="radioAnswer(indxAns, t(answer))" />
                        </label>
                    </form>
                    <div class="btn-start-block">
                        <button size="l" appearance="primary" tuiAppearanceMode="" tuiButton type="button"
                            class="tui-space_bottom-4 tui-space_top-5"
                            (click)="btnAnswerType2(indx, t(thisQuestion.a))">{{ t('tickets.answer') }}</button>
                    </div>
                </div>
            </div>
            <div *ngSwitchCase="3">
                <div [ngClass]="{'hide': viewTicket !== indx}">
                    <h1 class="tui-space_bottom-10">{{ t('tickets.ticket') }} {{numbTicket}}, {{ t('tickets.question') }} {{indx + 1}} / {{questionsCount}}</h1>
                    <h2 class="tui-space_bottom-1">{{ t('tickets.how_would_respond') }} {{t('tickets.'+categoryPerson[thisQuestion.state].key.toLocaleLowerCase())}}?</h2>
                    <h4 class="tui-space_bottom-5">{{ t('tickets.multiple_answers') }}</h4>
                    <img class="img-text tui-space_top-5 tui-space_bottom-1 skeleton-img" src="{{environment.assertsUrl}}i/{{this.numbTicket}}_{{indx+1}}.jpg">
                    <form orientation="vertical" tuiGroup class="group tui-space_top-3 tui-space_bottom-3 form-answers"
                        [collapsed]="true" [formGroup]="type3QuestionsForm">
                        <label tuiBlock [style.justify-content]="'space-between'"
                            *ngFor="let item of thisQuestion.a;  let indxAnsCheckbox = index;">
                            {{ t(item.text) }}
                            <input tuiCheckbox type="checkbox" [value]="item.checked" [formControlName]="indxAnsCheckbox"
                                (click)="item.checked = !item.checke" />
                        </label>
                    </form>
                    <div class="btn-start-block">
                        <button size="l" appearance="primary" tuiAppearanceMode="" tuiButton type="button"
                            class="tui-space_bottom-4 tui-space_top-5"
                            (click)="btnAnswerType3(indx, thisQuestion.a)">{{ t('tickets.answer') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [ngClass]="{'hide': viewTicket < questionsCount}">
        <div class="results-container tui-space_top-5" *ngIf="showResults">
            <h2 class="tui-space_bottom-4">{{ t('tickets.results') }} №{{numbTicket}}</h2>
            <div class="results-list">
                <div *ngFor="let question of thisQuestions; let i = index" class="result-item tui-space_bottom-4">
                    <div class="tui-space_bottom-2">
                        <h3>{{ t('tickets.question') }} {{i + 1}}</h3>
                        <p class=" question-header tui-text_body-l" *ngIf="question.type !== 3">{{ t(question.q) }}</p>
                    </div>
    
                    <div class="answer-section" [ngSwitch]="question.type">
                        <!-- Type 1: Ego state questions -->
                        <div *ngSwitchCase="1">
                            <p class="tui-space_bottom-2">{{ t('tickets.your_answer') }}:
                                <span
                                    [ngClass]="{'correct': userAnswer[i] == question.trueA, 'incorrect': userAnswer[i] != question.trueA}">
                                    {{t('tickets.'+categoryPerson[userAnswer[i]]?.key.toLocaleLowerCase()) || t('tickets.not_answered') }} 
                                </span>
                            </p>
                            <p *ngIf="userAnswer[i] != question.trueA" class="correct-answer">
                                {{ t('tickets.correct_answer') }}: {{ t('tickets.'+categoryPerson[question.trueA].key.toLocaleLowerCase())}}
                            </p>
                        </div>
    
                        <!-- Type 2: Single choice questions -->
                        <div *ngSwitchCase="2">
                            <p class="tui-space_bottom-4">{{ t('tickets.how_would_respond') }} {{t('tickets.'+categoryPerson[question.state].key.toLocaleLowerCase())}}?</p>
                            <p class="tui-space_bottom-2">{{ t('tickets.your_answer') }}:
                                <span
                                    [ngClass]="{'correct': userAnswer[i] == question.trueA, 'incorrect': userAnswer[i] != question.trueA}">
                                    {{t(question.a[userAnswer[i]]) || t('tickets.not_answered') }}
                                </span>
                            </p>
                            <p *ngIf="userAnswer[i] != question.trueA" class="correct-answer">
                                {{ t('tickets.correct_answer') }}: {{t(question.a[question.trueA])}}
                            </p>
                        </div>
    
                        <!-- Type 3: Multiple choice questions -->
                        <div *ngSwitchCase="3">
                                                        <p class="question-header tui-text_body-l tui-space_bottom-2">{{ t('tickets.how_would_respond') }}
                                {{t('tickets.'+categoryPerson[question.state].key.toLocaleLowerCase())}}?</p>
                            <div class="tui-space_bottom-2">{{ t('tickets.your_answer') }}:
                                <div *ngFor="let answer of userAnswer[i]; let j = index">
                                    <div *ngIf="answer.checked"
                                        [ngClass]="{'correct': answer.state, 'incorrect': !answer.state}">
                                        {{t(answer.text) || t('tickets.not_answered') }}
                                    </div>
                                </div>

                            </div>
                            <div class="correct-answer">
                                {{ t('tickets.correct_answer') }}:
                                <div *ngFor="let answer of userAnswer[i]; let j = index">
                                    <div *ngIf="answer.state"
                                        [ngClass]="{'correct': answer.state, 'incorrect': !answer.state}">
                                        {{t(answer.text) || t('tickets.not_answered') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="btn-start-block">
            <button size="l" appearance="primary" tuiAppearanceMode="" (click)="shareResult()" tuiButton type="button"
                class="tui-space_bottom-3 tui-space_top-6">{{ t('tickets.share_with_friends') }}</button>
            <!-- Иконки соцсетей -->
            <!-- <div class="social-share">
                    <a [href]="getFacebookShareUrl()" target="_blank"><tui-icon icon="@tui.facebook" /></a>
                    <a [href]="getTwitterShareUrl()" target="_blank"><tui-icon icon="@tui.twitter" /></a>
                    <a [href]="getTelegramShareUrl()" target="_blank"><tui-icon icon="@tui.telegram" /></a>
                    <a [href]="getWhatsAppShareUrl()" target="_blank"><tui-icon icon="@tui.whatsapp" /></a>
                </div> -->
            <button size="l" appearance="outline" tuiAppearanceMode="" tuiButton type="button"
                class="tui-space_bottom-4 tui-space_top-2"
                (click)="router.navigate([ROUTES_CONST.TRAINING, ROUTES_CONST.PRACTICE])">{{ t('tickets.back_to_tickets') }}</button>
            <button size="l" appearance="flat" tuiAppearanceMode="" tuiButton type="button"
                class="tui-space_bottom-4 tui-space_top-2" (click)="router.navigate([ROUTES_CONST.TRAINING])">{{ t('tickets.learn_ego_states') }}</button>
        </div>
        <!-- <div class="btn-start-block">
            <button size="l" appearance="primary" tuiAppearanceMode="" tuiButton type="button"
                class="tui-space_bottom-4 tui-space_top-5" (click)="showResults = true; getResultTest()">Результат</button>
        </div> -->
    </div>
</ng-container>

